import Form from "components/Form";
import Layout from "components/Layout";
import { FunctionComponent } from "react";

const DevelopPage: FunctionComponent<{}> = ({}) => {
  return (
    <Layout>
      {/* <Head>
        <meta property="og:title" content="Decks | Deck Generator Baseball Superstars 2020"></meta>
        <meta property="og:description" content="Decks generator for Baseball Superstars 2020"></meta>
        <title>Decks | Deck Generator Baseball Superstars 2020</title>
      </Head> */}
      <Form />
    </Layout>
  );
};

export default DevelopPage;
